import * as React from "react";
import styled from "styled-components";
import { Link } from "components/common";
import usePluginEntities from "hooks/usePluginEntities";
import { useGetEntityRoute } from "routing/hooks/useShowRouteForEntity";
import ExternalLink from "components/common/ExternalLink";
import useRightSidebar from "hooks/useRightSidebar";
import resolveGraylogUri from "./resolveGraylogUri";
const GRAYLOG_URI_PREFIX = "graylog:///";
const useResolvedGraylogLink = (href) => {
  const resolvers = usePluginEntities("markdown.entityLinkResolvers");
  const getEntityRoute = useGetEntityRoute();
  if (!href.startsWith(GRAYLOG_URI_PREFIX)) {
    return null;
  }
  const resolved = resolveGraylogUri(href, resolvers);
  if (!resolved) {
    return null;
  }
  if ("onClick" in resolved) {
    return { onClick: resolved.onClick };
  }
  return { to: getEntityRoute(resolved.id, resolved.grnType), id: resolved.id, Title: resolved.Title };
};
const SidebarLink = styled.a`
  cursor: pointer;
`;
const OnClickLink = ({ handler, children }) => {
  const { openSidebar } = useRightSidebar();
  const openInSidebar = () => handler({ openSidebar });
  return /* @__PURE__ */ React.createElement(
    SidebarLink,
    {
      role: "link",
      tabIndex: 0,
      onClick: openInSidebar,
      onKeyDown: (event) => {
        if (event.key === "Enter") {
          openInSidebar();
        }
      }
    },
    children
  );
};
const MarkdownLink = ({ href, children = null }) => {
  const resolved = useResolvedGraylogLink(href);
  if (resolved && "to" in resolved) {
    const { to, id, Title } = resolved;
    return /* @__PURE__ */ React.createElement(Link, { to }, Title ? /* @__PURE__ */ React.createElement(Title, { id }, children) : children);
  }
  if (resolved && "onClick" in resolved) {
    return /* @__PURE__ */ React.createElement(OnClickLink, { handler: resolved.onClick }, children);
  }
  return /* @__PURE__ */ React.createElement(ExternalLink, { href }, children);
};
export default MarkdownLink;
